import ATableFullPage from 'views/components/Table/ATableFullPage'
import { ListRequestParams } from 'modules/domain/types'
import useRailsColumns from './useRailsColumns'
import { WrapperWithForcedScroll } from 'views/components/Table/styled'

type Props = {
  listRequestParams: ListRequestParams
  setListRequestParams: (params: ListRequestParams) => void
  isFiltersLoaded?: boolean
  dataEndpoint: string
  onSuccess: () => void
}
export const RailsRatesTable = ({
  listRequestParams,
  setListRequestParams,
  isFiltersLoaded,
  onSuccess,
  dataEndpoint,
}: Props) => {
  const columns = useRailsColumns(onSuccess, listRequestParams.sort)

  return (
    <WrapperWithForcedScroll>
      <ATableFullPage
        columns={columns}
        dataEndpoint={dataEndpoint}
        listParamsUpdated={setListRequestParams}
        listRequestParams={listRequestParams}
        isFiltersLoaded={isFiltersLoaded}
        rowHoverGray
      />
    </WrapperWithForcedScroll>
  )
}
